package com.essntl.features.organization.ui.organizationdetails.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.foundation.interaction.collectIsPressedAsState
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.focusProperties
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.essntl.features.contact.domain.model.ContactModel
import com.essntl.features.organization.ui.organizationdetails.OrganizationDetailsNavigation
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.EsRowDefaultItem
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ContactItem(
    contact: ContactModel,
    isSelected: Boolean,
    showDivider: Boolean,
    onNavigation: (OrganizationDetailsNavigation) -> Unit,
    modifier: Modifier = Modifier,
) {
    val interactionSource = remember { MutableInteractionSource() }

    val isHovered by interactionSource.collectIsHoveredAsState()

    val isPressed by interactionSource.collectIsPressedAsState()

    Column(
        modifier = modifier
            .clip(
                RoundedCornerShape(
                    EsConstants.RoundedCornerSize,
                ),
            ),
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier =
                Modifier
                    .background(MaterialTheme.esColorScheme.bgSecondary)
                    .background(
                        when {
                            isSelected ->
                                MaterialTheme.esColorScheme.tintedPressed

                            isPressed ->
                                MaterialTheme.esColorScheme.tintedPressed

                            isHovered ->
                                MaterialTheme.esColorScheme.tintedHover

                            else ->
                                Color.Transparent
                        },
                    )
                    .padding(
                        vertical = EsConstants.ListRowVerticalPadding,
                        horizontal = EsConstants.ListRowHorizontalPadding,
                    )
                    .pointerHoverIcon(PointerIcon.Hand)
                    .height(EsConstants.ListRowItemHeight)
                    .focusProperties { canFocus = false }
                    .clickable(
                        interactionSource = interactionSource,
                        indication = null,
                        onClick = {
                            onNavigation(
                                OrganizationDetailsNavigation.EditContact(
                                    id = contact.id,
                                ),
                            )
                        },
                    ),
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier =
                    Modifier
                        .weight(2f)
                        .fillMaxHeight(),
            ) {
                Box(
                    contentAlignment = Alignment.Center,
                    modifier =
                        Modifier
                            .weight(2f)
                            .fillMaxSize(),
                ) {
                    Text(
                        text = contact.prettyName.takeIf{ it.isNotBlank()} ?: "-",
                        color = MaterialTheme.esColorScheme.textPrimary,
                        style = MaterialTheme.esTypography.s2SemiBold16,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                        modifier = Modifier.align(Alignment.CenterStart),
                    )
                }
            }

            EsRowDefaultItem(
                text = contact.email ?: "-",
            )

            EsRowDefaultItem(
                text = contact.phoneNumber ?: "-",
            )

            EsRowDefaultItem(
                text = contact.notes ?: "-",
                weight = 2f,
            )
        }

        if (showDivider)
            HorizontalDivider(
                thickness = 1.dp,
                color = MaterialTheme.esColorScheme.borderPrimary,
            )
    }
}